export const isDevelopment = () => {
  const urlObj = new URL(window.location.href);
  return (
    process.env.NODE_ENV == "development" ||
    urlObj.hostname === "backups.3v3.farm"
  );
};

export const isLocalhost = () =>
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "::1";

export const retrieveCurrentUrl = () => {
  const urlDev = window.localStorage.getItem("url");
  const isDev = isDevelopment();
  const isLocal = isLocalhost();
  let url = window.origin;

  if (isDev && urlDev) {
    url = urlDev;
  } else if (isLocal) {
    url = "http://localhost:80";
  }

  return url;
};
